import React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ActionButtonSizes, ActionButtonVariants, ActionLink } from 'components/action-button';
import { LOYALTY_ERROR_PLACEHOLDER } from 'hooks/loyalty/constants';
import { useAuthContext } from 'state/auth';
import { IActiveCardDetails } from 'state/loyalty/types';

const Container = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: ${Styles.color.primary};
  background-size: cover;
  width: 100%;
  /* this is to prevent a flash resize due to custom fonts being used */
  min-height: 110px;
`;

const Info = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0rem 1rem 0.75rem;
`;

const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0;
`;

const Header = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-weight: normal;
  font-size: 1.4rem;
  color: ${Styles.color.white};
  line-height: 2rem;
  margin: 0;
  padding: 0;
`;

const SubHeader = styled.p`
  font-size: 1.5rem;
  font-weight: ${Styles.fontWeight.normal};
  color: ${Styles.color.white};
  width: 100%;
  margin-top: 0.2rem;
  text-shadow: none;
  margin: 0;
  padding: 0;
  line-height: 1.5rem;
`;
const Description = styled.p`
  font-size: 1rem;
  color: ${Styles.color.white};
  margin: 0;
`;
const Points = styled.span`
  font-weight: ${Styles.fontWeight.heavy};
`;

interface IMainHero {
  actionTo: string;
  header?: string;
  actionText: string;
  subHeader?: string;
  descriptionText?: string;
  isLoading: boolean;
  loyaltyDetails: IActiveCardDetails | null;
}

const RewardsHeader = ({ actionText, loyaltyDetails, actionTo, descriptionText }: IMainHero) => {
  const { user } = useAuthContext();
  const firstName = (user && user.details.name.split(' ')[0]) || '';
  const { formatMessage } = useIntl();
  const description = descriptionText || formatMessage({ id: 'loyaltyHeaderDescription' });

  return (
    <Container>
      <Info>
        <InfoText>
          <Header>{formatMessage({ id: 'loyaltyHeaderGreeting' }, { firstName })}</Header>
          <SubHeader>
            {formatMessage(
              { id: 'loyaltyHeaderPointsMessage' },
              {
                points: (
                  <Points>
                    {loyaltyDetails ? loyaltyDetails.points : LOYALTY_ERROR_PLACEHOLDER}
                  </Points>
                ),
              }
            )}
          </SubHeader>
          <Description>{description}</Description>
        </InfoText>
      </Info>
      <Box margin="1rem 1rem 0 0">
        <ActionLink
          size={ActionButtonSizes.SMALL}
          variant={ActionButtonVariants.INVERSE}
          to={actionTo}
        >
          {actionText}
        </ActionLink>
      </Box>
    </Container>
  );
};

export default RewardsHeader;
